import { configureStore, combineReducers } from "@reduxjs/toolkit";
import authSlice from "./slices/AuthSlice";
import dealSlice from "./slices/DealSlice";
import profileSlice from "./slices/ProfileSlice";
import manageFundSlice from "./slices/manageFundSlice";
import dashboardSlice from "./slices/dashboardSlice";
import ordersSlice from "./slices/OrdersSlice";
import OnboardingSlice from "./slices/OnboardingSlice";
import ReportsSlice from "./slices/ReportsSlice";
import EsignSlice from "./slices/EsignSlice";
import NotifySlice from "./slices/NotifySlice";
import DocumentSlice from "./slices/DocumentSlice";

const rootReducer = combineReducers({
  auth: authSlice,
  dashboard: dashboardSlice,
  deal: dealSlice,
  profile: profileSlice,
  manageFunds: manageFundSlice,
  orders: ordersSlice,
  questionnaire: OnboardingSlice,
  reports: ReportsSlice,
  esign: EsignSlice,
  notification: NotifySlice,
  docs: DocumentSlice
});

const store = configureStore({
  reducer: rootReducer,
});

export default store;
